import { EXPLORE_FILTER_LOCALITY } from './use-experience-filter';
import useSetFilter, { LocalityKey } from './use-set-filter';

const useSetLocality = () => useSetFilter<LocalityKey>(EXPLORE_FILTER_LOCALITY);

export default useSetLocality;
